module.exports = __webpack_public_path__ + "img/tagline.dd31b487.png";